import React from 'react';

const Adatkezeles = () => {
  return (
    <div className="min-h-screen px-4 sm:px-6 lg:px-8 py-16">
      <div className="max-w-3xl mx-auto bg-white/[0.03] border border-white/10 rounded-2xl p-8 sm:p-12 shadow-[0_0_30px_rgba(0,0,0,0.5)]">
        <h1 className="brand glow text-center text-yellow-200 text-5xl mb-10">Adatkezelési tájékoztató</h1>

        <p className="text-gray-200 mb-8">
          Jelen adatkezelési tájékoztató célja, hogy a <strong className="text-white">celestinethewitch.hu</strong> weboldal látogatói megismerjék, milyen adatokat kezelünk, milyen célból, és milyen jogaik vannak az adatkezeléssel kapcsolatban.
        </p>

        <section className="mb-8">
          <h2 className="text-[#d6c090] text-xl font-semibold border-b border-white/10 pb-2 mb-4">1. Adatkezelő adatai</h2>
          <p className="text-gray-200 mb-1"><strong className="text-white">Név:</strong> Tóth Eszter E.V.</p>
          <p className="text-gray-200 mb-1"><strong className="text-white">Székhely:</strong> 1033 Budapest, Harrer Pál utca 16/52.</p>
          <p className="text-gray-200 mb-1"><strong className="text-white">Nyilvántartási szám:</strong> 60753388</p>
          <p className="text-gray-200 mb-1"><strong className="text-white">Adószám:</strong> 90231991-1-41</p>
          <p className="text-gray-200 mb-1">
            <strong className="text-white">E-mail:</strong>{' '}
            <a href="mailto:celestinethewitch@gmail.com" className="text-yellow-200 hover:underline">celestinethewitch@gmail.com</a>
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-[#d6c090] text-xl font-semibold border-b border-white/10 pb-2 mb-4">2. Kezelt adatok köre</h2>
          <ul className="list-disc list-inside space-y-2 text-gray-200">
            <li><strong className="text-white">E-mail kommunikáció:</strong> Az e-mailben történő kapcsolatfelvétel során megadott név és e-mail cím.</li>
            <li><strong className="text-white">Rendelési adatok:</strong> Megrendelés esetén a számlázáshoz és szállításhoz szükséges adatok (név, cím, e-mail, telefonszám).</li>
            <li><strong className="text-white">Technikai adatok:</strong> A tárhelyszolgáltató automatikusan gyűjthet adatokat, mint IP-cím, böngésző típusa, látogatás ideje – kizárólag biztonsági és működési célból.</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-[#d6c090] text-xl font-semibold border-b border-white/10 pb-2 mb-4">3. Az adatkezelés célja</h2>
          <p className="text-gray-200">
            Az adatkezelés célja az érdeklődők kérdéseinek megválaszolása, a kapcsolatfelvétel biztosítása, valamint a megrendelések teljesítése és a számlázás. Az adatokat más célra nem használjuk, harmadik félnek – a teljesítéshez szükséges szolgáltatókon kívül – nem adjuk át.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-[#d6c090] text-xl font-semibold border-b border-white/10 pb-2 mb-4">4. Az adatkezelés jogalapja</h2>
          <p className="text-gray-200">
            Az adatkezelés az <strong className="text-white">érintett hozzájárulása</strong> (GDPR 6. cikk (1) a) pont), illetve megrendelés esetén a <strong className="text-white">szerződés teljesítése</strong> (GDPR 6. cikk (1) b) pont) alapján történik.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-[#d6c090] text-xl font-semibold border-b border-white/10 pb-2 mb-4">5. Az adatok megőrzésének ideje</h2>
          <p className="text-gray-200">
            Az e-mailes megkeresések adatait legfeljebb <strong className="text-white">6 hónapig</strong> őrizzük meg. A számviteli bizonylatokat a jogszabályi kötelezettségnek megfelelően <strong className="text-white">8 évig</strong> tároljuk.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-[#d6c090] text-xl font-semibold border-b border-white/10 pb-2 mb-4">6. Az adatokhoz való hozzáférés</h2>
          <p className="text-gray-200">
            Az adatokhoz kizárólag az adatkezelő (Tóth Eszter E.V.) fér hozzá. Harmadik fél számára az adatokat nem továbbítjuk, kivéve, ha azt jogszabály írja elő, vagy a megrendelés teljesítéséhez szükséges (pl. futárszolgálat, fizetési szolgáltató).
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-[#d6c090] text-xl font-semibold border-b border-white/10 pb-2 mb-4">7. Az érintettek jogai</h2>
          <ul className="list-disc list-inside space-y-2 text-gray-200">
            <li>Tájékoztatást kérhet a kezelt adatairól,</li>
            <li>Kérheti azok helyesbítését vagy törlését,</li>
            <li>Korlátozhatja az adatkezelést,</li>
            <li>Tiltakozhat az adatkezelés ellen,</li>
            <li>Jogorvoslattal élhet a NAIH-nál: <a href="https://naih.hu" target="_blank" rel="noreferrer" className="text-yellow-200 hover:underline">https://naih.hu</a></li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-[#d6c090] text-xl font-semibold border-b border-white/10 pb-2 mb-4">8. Adatbiztonság</h2>
          <p className="text-gray-200">
            Az adatokat biztonságos módon kezeljük, illetéktelen hozzáférés, módosítás vagy nyilvánosságra hozatal ellen védve. A weboldal SSL titkosítást alkalmaz, és a tárhelyszolgáltató rendszeresen karbantartott biztonsági infrastruktúrát használ.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-[#d6c090] text-xl font-semibold border-b border-white/10 pb-2 mb-4">9. Cookie-k</h2>
          <p className="text-gray-200">
            A weboldal jelenleg nem használ követő- vagy analitikai cookie-t. A működéshez szükséges technikai cookie-k (pl. kosár, bejelentkezés) használatban lehetnek. Amennyiben a jövőben analitikai cookie-kat vezetünk be, a látogatók előzetes hozzájárulását fogjuk kérni.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-[#d6c090] text-xl font-semibold border-b border-white/10 pb-2 mb-4">10. Záró rendelkezések</h2>
          <p className="text-gray-200">
            Jelen adatkezelési tájékoztató 2025. január 1. napjától hatályos, és visszavonásig érvényben marad. A dokumentum frissítése esetén az új verzió a weboldalon kerül közzétételre.
          </p>
        </section>

        <div className="text-center mt-12 text-sm text-[#b3a693]">
          © {new Date().getFullYear()} Celestine – Minden jog fenntartva.
        </div>
      </div>

      <style jsx>{`
        .brand {
          font-family: "Great Vibes", cursive;
        }
        .glow {
          text-shadow: 0 0 12px rgba(255, 255, 255, 0.35), 0 0 24px rgba(199, 146, 12, 0.25);
        }
      `}</style>
    </div>
  );
};

export default Adatkezeles;
